import React from 'react';
import { useAdministrationOverlay } from '@piwikpro/router-crate';
import CreateUserGroupRoute from './CreateUserGroup/CreateUserGroupRoute';

/** List-level create overlays; URL suffix via administrationOverlayRewrite. */
const UserGroupsListOverlay: React.FC = () => {
  const overlay = useAdministrationOverlay();

  if (overlay === '/m/create') {
    return <CreateUserGroupRoute />;
  }

  return null;
};

export default UserGroupsListOverlay;
